import { render, staticRenderFns } from "./CardsSlider.vue?vue&type=template&id=f33f970a&"
import script from "./CardsSlider.vue?vue&type=script&lang=js&"
export * from "./CardsSlider.vue?vue&type=script&lang=js&"
import style0 from "./CardsSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports